import * as z from "zod";

const MoneyV2Schema = z.object({
  amount: z.string(),
  currencyCode: z.string(),
});

const DiscountAllocationSchema = z.object({
  amount: MoneyV2Schema,
  discount: z.object({ code: z.string() }),
});

const CartLineNodeSchema = z.object({
  id: z.string(),
  quantity: z.number(),
  discountAllocations: z.array(DiscountAllocationSchema).optional(),
  cost: z.object({ totalAmount: MoneyV2Schema }),
  merchandise: z.object({
    id: z.string(),
    availableForSale: z.boolean(),
    image: z.object({ originalSrc: z.string(), url: z.string() }).nullish(),
    title: z.string(),
    price: MoneyV2Schema,
    selectedOptions: z.array(z.object({ name: z.string(), value: z.string() })),
    product: z.object({
      id: z.string(),
      title: z.string(),
      vendor: z.string(),
      options: z.array(
        z.object({
          id: z.string(),
          name: z.string(),
          values: z.array(z.string()),
        }),
      ),
      onlineStoreUrl: z.string().nullish(),
    }),
  }),
});

const CartSchema = z.object({
  id: z.string(),
  totalQuantity: z.number(),
  checkoutUrl: z.string(),
  cost: z.object({
    subtotalAmount: MoneyV2Schema,
    totalAmount: MoneyV2Schema,
    totalTaxAmount: MoneyV2Schema.nullish(),
    checkoutChargeAmount: MoneyV2Schema,
  }),
  lines: z.object({ edges: z.array(z.object({ node: CartLineNodeSchema })) }),
});

export enum GetCartDetailsError {
  CartNotFound = "CartNotFound",
  InvalidCartId = "InvalidCartId",
}

export const getCartDetails = {
  name: "getCartDetails" as const,
  method: "unary" as const,
  input: z.object({ cartId: z.string() }),
  output: z.object({ cart: CartSchema }),
};
